import fetch from '@/utils/fetch'

export const getGoodList = (body: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/frontconfig/goodslist',
    data: body,
  })

export interface NewUserGoodListParams {
  page: number
  pageSize: number
  countryCode: string
  currencyCode?: string
  language: string
  level1CategoryId: number
}

// 商品id获取商品流
export function getProductFeedList(body: any = {}, headers: any = {}) {
  return fetch.post({
    url: '/api/v1/h5/activity/fire/activity-platform/product/feeds/normal/detail',
    data: body,
    headers,
  })
}

export const getNewUserGoodList = (body: NewUserGoodListParams, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/frontconfig/query/newgoods',
    data: body,
    headers,
  })

export const getLatestBidList = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/center/oversea/query-latest-bidding-spu',
    data: body,
    headers,
  })

export const getRecommendedGoodList = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/frontconfig/daily/commodity',
    data: body,
    headers,
  })

export const getBuyerNewgoods = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/frontconfig/buyer/newgoods',
    data: body,
    headers,
  })

export const h5FirstGoodsInfo = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/frontconfig/save/h5FirstGoodsInfo',
    data: body,
    headers,
  })

// 获取榜单TabList
export const getL1TabList = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/center/oversea/top/v1/h5/tab',
    data: body,
    headers,
  })

// 获取榜单商品列表
export const getBooklistByType = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/center/oversea/top/v1/h5/list',
    data: body,
    headers,
  })

export const guessYouLike = (body: any = {}, headers: any = {}) =>
  fetch.post({
    url: '/api/v1/h5/adapter/center/oversea/top/v1/h5/guessYouLike',
    data: body,
    headers,
  })
